module.exports = __webpack_public_path__ + "img/bannerNew.f1f11c1f.png";